// material-ui
import { alpha, useTheme } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import FormControl from '@mui/material/FormControl';
import InputAdornment from '@mui/material/InputAdornment';
import OutlinedInput from '@mui/material/OutlinedInput';

// assets
import SearchOutlined from '@ant-design/icons/SearchOutlined';

// ==============================|| HEADER CONTENT - SEARCH ||============================== //

export default function Search() {
  const theme = useTheme();

  return (
    <Box sx={{ minWidth: 280 }}>
      <FormControl sx={{ width: '100%' }}>
        <OutlinedInput
          size="small"
          readOnly
          startAdornment={
            <InputAdornment position="start" sx={{ mr: 0.5 }}>
              <SearchOutlined />
            </InputAdornment>
          }
          endAdornment={<Chip label="Ctrl K" size="small" sx={{ borderRadius: 999 }} />}
          placeholder="Tìm bài thi, lớp học, lịch sử..."
          sx={{
            borderRadius: 999,
            backgroundColor: alpha(theme.palette.background.default, theme.palette.mode === 'dark' ? 0.6 : 0.9),
            '& .MuiOutlinedInput-notchedOutline': {
              borderColor: alpha(theme.palette.divider, 1)
            }
          }}
        />
      </FormControl>
    </Box>
  );
}
